import React, { useEffect, useState } from "react";
import axios from "axios";

const ShowRoomBaghdadLocationEditor = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [dataLoaded, setDataLoaded] = useState(false);
  const [msg, setMsg] = useState("");

  const [form, setForm] = useState({
    titleEn: "",
    titleAr: "",
    titleKu: "",

    subtitleEn: "",
    subtitleAr: "",
    subtitleKu: "",

    descriptionEn: "",
    descriptionAr: "",
    descriptionKu: "",

    addressEn: "",
    addressAr: "",
    addressKu: "",

    hoursEn: "",
    hoursAr: "",
    hoursKu: ""
  });

  // ===================================================
  // LOAD ALL LANGUAGES
  // ===================================================
  useEffect(() => {
    const load = async () => {
      try {
        const en = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadLocation?lang=en`
        );
        const ar = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadLocation?lang=ar`
        );
        const ku = await axios.get(
          `${API_BASE}/api/ShowRoomBaghdadLocation?lang=ku`
        );

        setForm({
          titleEn: en.data.title || "",
          titleAr: ar.data.title || "",
          titleKu: ku.data.title || "",

          subtitleEn: en.data.subtitle || "",
          subtitleAr: ar.data.subtitle || "",
          subtitleKu: ku.data.subtitle || "",

          descriptionEn: en.data.description || "",
          descriptionAr: ar.data.description || "",
          descriptionKu: ku.data.description || "",

          addressEn: en.data.address || "",
          addressAr: ar.data.address || "",
          addressKu: ku.data.address || "",

          hoursEn: en.data.hours || "",
          hoursAr: ar.data.hours || "",
          hoursKu: ku.data.hours || "",
        });

        setDataLoaded(true);
      } catch (err) {
        console.error("Failed loading ShowRoomBaghdadLocation:", err);
      }
    };

    load();
  }, [API_BASE]);

  if (!dataLoaded)
    return <div className="p-4">Loading...</div>;

  // ===================================================
  // SAVE TEXT
  // ===================================================
  const saveText = async () => {
    setMsg("");

    try {
      await axios.put(
        `${API_BASE}/api/ShowRoomBaghdadLocation/1`,
        form,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      setMsg("Content updated successfully.");
    } catch (err) {
      console.error(err);
      setMsg("Failed updating content.");
    }
  };

  return (
    <div className="p-4">
      <h2 className="mb-4">ShowRoom Baghdad Location Editor</h2>

      {msg && <div className="alert alert-info">{msg}</div>}

      {/* =============================== */}
      {/* TITLE SECTION                   */}
      {/* =============================== */}
      <h4 className="mt-4">Title</h4>

      <label>English</label>
      <input
        className="form-control mb-2"
        value={form.titleEn}
        onChange={(e) => setForm({ ...form, titleEn: e.target.value })}
      />

      <label>Arabic</label>
      <input
        className="form-control mb-2"
        value={form.titleAr}
        onChange={(e) => setForm({ ...form, titleAr: e.target.value })}
      />

      <label>Kurdish</label>
      <input
        className="form-control mb-4"
        value={form.titleKu}
        onChange={(e) => setForm({ ...form, titleKu: e.target.value })}
      />

      {/* =============================== */}
      {/* SUBTITLE SECTION                */}
      {/* =============================== */}
      <h4 className="mt-4">Subtitle</h4>

      <label>English</label>
      <input
        className="form-control mb-2"
        value={form.subtitleEn}
        onChange={(e) => setForm({ ...form, subtitleEn: e.target.value })}
      />

      <label>Arabic</label>
      <input
        className="form-control mb-2"
        value={form.subtitleAr}
        onChange={(e) => setForm({ ...form, subtitleAr: e.target.value })}
      />

      <label>Kurdish</label>
      <input
        className="form-control mb-4"
        value={form.subtitleKu}
        onChange={(e) => setForm({ ...form, subtitleKu: e.target.value })}
      />

      {/* =============================== */}
      {/* DESCRIPTION SECTION             */}
      {/* =============================== */}
      <h4 className="mt-4">Description</h4>

      <label>English</label>
      <textarea
        className="form-control mb-2"
        rows={3}
        value={form.descriptionEn}
        onChange={(e) => setForm({ ...form, descriptionEn: e.target.value })}
      />

      <label>Arabic</label>
      <textarea
        className="form-control mb-2"
        rows={3}
        value={form.descriptionAr}
        onChange={(e) => setForm({ ...form, descriptionAr: e.target.value })}
      />

      <label>Kurdish</label>
      <textarea
        className="form-control mb-4"
        rows={3}
        value={form.descriptionKu}
        onChange={(e) => setForm({ ...form, descriptionKu: e.target.value })}
      />

      {/* =============================== */}
      {/* ADDRESS SECTION                 */}
      {/* =============================== */}
      <h4 className="mt-4">Address</h4>

      <label>English</label>
      <input
        className="form-control mb-2"
        value={form.addressEn}
        onChange={(e) => setForm({ ...form, addressEn: e.target.value })}
      />

      <label>Arabic</label>
      <input
        className="form-control mb-2"
        value={form.addressAr}
        onChange={(e) => setForm({ ...form, addressAr: e.target.value })}
      />

      <label>Kurdish</label>
      <input
        className="form-control mb-4"
        value={form.addressKu}
        onChange={(e) => setForm({ ...form, addressKu: e.target.value })}
      />

      {/* =============================== */}
      {/* HOURS SECTION                   */}
      {/* =============================== */}
      <h4 className="mt-4">Opening Hours</h4>

      <label>English</label>
      <textarea
        className="form-control mb-2"
        rows={2}
        value={form.hoursEn}
        onChange={(e) => setForm({ ...form, hoursEn: e.target.value })}
      />

      <label>Arabic</label>
      <textarea
        className="form-control mb-2"
        rows={2}
        value={form.hoursAr}
        onChange={(e) => setForm({ ...form, hoursAr: e.target.value })}
      />

      <label>Kurdish</label>
      <textarea
        className="form-control mb-4"
        rows={2}
        value={form.hoursKu}
        onChange={(e) => setForm({ ...form, hoursKu: e.target.value })}
      />

      <button
        className="btn btn-primary w-100 mt-3"
        onClick={saveText}
      >
        Save Content
      </button>
    </div>
  );
};

export default ShowRoomBaghdadLocationEditor;
